import { Component, OnInit } from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/api';
import {constants} from '../app-constants';
import {AnexoOsDialogComponent} from '../anexo-os-dialog/anexo-os-dialog.component';

@Component({
  selector: 'app-ordem-servico-dialog',
  templateUrl: './ordem-servico-dialog.component.html',
  styleUrls: ['./ordem-servico-dialog.component.css']
})
export class OrdemServicoDialogComponent implements OnInit {

  public osS;
  public checklist: Array<any> = [];
  public constants = constants;
  public material: Array<any> = [];
  public ativo: Array<any> = [];
  public anexo: Array<any> = [];
  public ambiente: Array<any> = [];
  private showClosed;

  constructor(public config: DynamicDialogConfig,
              public dialogService: DialogService) {
  }

  ngOnInit() {
    this.osS = JSON.parse(this.config.data);
    if (this.osS.osAmbiente != null) {
      this.osS.osAmbientes.forEach(item => {
        this.ambiente.push(item);
      });
    }
    this.osS.pesquisas.forEach( item => {
      item.pesquisaRespostaOut.forEach(item2 => {
        this.checklist.push(item2);
      });
    });
    this.osS.listaAnexoOuts.forEach(item => {
      this.anexo.push(item);
    });
    if (this.osS.status === 7) {
      this.osS.osMaterial.forEach(item => {
        this.material.push(item);
      });
      if (this.osS.historicoAtivo != null) {
        this.osS.historicoAtivo.forEach(item => {
          this.ativo.push(item);
        });
      }
      this.showClosed = document.getElementsByClassName('isClosed');
      for (let i = 0; i < this.showClosed.length; i++) {
        this.showClosed[i].style.display = 'inline';
      }
    } else {
      this.material = null;
      this.ativo = null;
    }
  }
  showDialog(anx) {
    const ref = this.dialogService.open(AnexoOsDialogComponent, {
      data: anx.pathServer,
      header: anx.nomeArquivo,
      width: '70%',
      height: '70%'
    });
  }
}
